import React, { useEffect, useState } from "react";
import axiosConfig from "../../axiosConfig";
import MaterialTable, { MTableToolbar } from "material-table";
import { tableIcons } from "../../shared/TableIcons";
import AddBox from "@material-ui/icons/AddBox";
import { useHistory } from "react-router-dom";
import { CSVReader } from "react-papaparse";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";
import axios from "axios";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import { makeStyles } from "@material-ui/core/styles";
import UpdateIcon from '@material-ui/icons/Update';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import Edit from "@material-ui/icons/Edit";
import Swal from "sweetalert2";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles(styles);

function Devices() {
  const history = useHistory();
  const [devices, setDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const classes = useStyles();

  useEffect(() => {
    const devicesPromise = axiosConfig.get("/Device/GetAllDevices");
    const deviceTypesPromise = axiosConfig.get("/Device/GetAllDeviceTypes");
    axios
      .all([devicesPromise, deviceTypesPromise])
      .then(
        axios.spread((...res) => {
          let devices = res[0].data;
          let deviceTypes = res[1].data;
          for (const device of devices) {
            let deviceType = deviceTypes.find(x => x.id === device.deviceTypeId);
            if (deviceType) {
              device.descriptionType = deviceType.description;
            }
          }
          setDevices(devices);
          setIsLoading(false);
        })
      )
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const buttonRef = React.createRef();

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  const handleOnRemoveFile = (data) => {
  };

  const handleOnDrop = (data) => {
    let imei, imsi;
    data.map((item) => {
      imei = item.data[0];
      imsi = item.data[1];
    });
  };

  const csv = () => {
    return (
      <CSVReader
        onDrop={handleOnDrop}
        onError={handleOnError}
        addRemoveButton
        removeButtonColor="#659cef"
        onRemoveFile={handleOnRemoveFile}
      >
        <span>
          Σύρετε το CSV αρχείο εδώ ή πατήστε για να ανεβάσετε CSV αρχείο.
        </span>
      </CSVReader>
    );
  };

  const restartDevice = (imei, deviceId) => {
    Swal.fire({
      title: "",
      text: `Πρόκειται να γίνει επανεκκίνηση της συσκευής με ΙΜΕΙ ${imei}. Είστε βέβαιοι;`,
      icon: "warning",
      position: "center",
      showCancelButton: true,
      container: "container-class",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ναι",
      cancelButtonText: "Οχι",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig.post(`Device/RestartDevice/${deviceId}`).then((res) => {

        })
      }
    })
  }
  const shutDownDevice = (imei, deviceId) => {
    Swal.fire({
      title: "",
      text: `Πρόκειται να γίνει απενεργοποίηση της συσκευής με ΙΜΕΙ ${imei}. Είστε βέβαιοι;`,
      icon: "warning",
      position: "center",
      showCancelButton: true,
      container: "container-class",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ναι",
      cancelButtonText: "Οχι",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig.post(`/Device/ShutDownDevice/${deviceId}`);
      }
    })
  }



  return (
    <Card>
      <CardHeader color="warning">
        <h1 className={classes.cardTitleWhite}>Όλες οι Συσκευές</h1>
      </CardHeader>
      <CardBody>
        <MaterialTable
          icons={tableIcons}
          title=""
          isLoading={isLoading}
          columns={[
            {
              title: "ID Συσκευής",
              field: "id",
            },
            { title: "Imei", field: "imei" },
            {
              title: "Τύπος Συσκευής",
              field: "descriptionType",
            },
            {
              title: "Διαθεσιμότητα",
              render: rowData => rowData.beneficiaryId ? "Δεσμευμένη" : "Αποδεσμευμένη",
            },
            {
              title: "Ημ/νια Ενημέρωσης Τελευταίου Σήματος",
              field: "lastStatusDate",
            },
            {
              title: "Ποσοστό Μπαταρίας",
              field: "lastBattery",
            },
            {
              title: "Ημ/νια Ενημέρωσης Ποσοστού Μπαταρίας",
              field: "lastBatteryDate",
            },
            {
              title: "Κατάσταση",
              render: rowData => rowData.isActive ? <Chip
                label="Λειτουργική"
                style={{ backgroundColor: "green", color: "white" }}
              /> : <Chip
                label="Μη Λειτουργική"
                style={{ backgroundColor: "red", color: "white" }}
              />
            },
          ]}
          data={devices}
          components={{
            Toolbar: (props) => (
              <div>
                <MTableToolbar {...props} />
                <div style={{ padding: "0px 10px" }}>{csv()}</div>
              </div>
            ),
          }}
          localization={{
            pagination: {
              firstTooltip: "Πρώτη Σελίδα",
              lastTooltip: "Τελευταία Σελίδα",
              previousTooltip: "Προηγούμενη Σελίδα",
              nextTooltip: "Επόμενη Σελίδα",
              labelDisplayedRows: "{from}-{to} από {count}",
              labelRowsSelect: "Εγγραφές ανά Σελίδα",
            },
          }}
          actions={[
            {
              icon: () => <AddBox />,
              onClick: () => {
                history.push({
                  pathname: "/add-device",
                });
              },
              isFreeAction: true,
              tooltip: "Προσθήκη",
            },
            {
              icon: () => <Edit />,
              tooltip: "Επεξεργασία/Λεπτομέρειες",
              onClick: (e, row) => {
                history.push({
                  pathname: "/edit-device",
                  selected: row.id,
                  locationPath: "editDevice"
                });
              },
            },
            {
              icon: () => <UpdateIcon />,
              tooltip: "Επανεκκίνηση",
              hidden: true,
              onClick: (e, row) => {
                restartDevice(row.imei, row.id);
              },
            },
            {
              icon: () => <PowerSettingsNewIcon />,
              tooltip: "Απενεργοποίηση",
              onClick: (e, row) => {
                shutDownDevice(row.imei, row.id);
              },
            }
          ]}
          localization={{
            body: {
              emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
              filterRow: {
                filterTooltip: 'Φίλτρο',
                filterPlaceHolder: 'Αναζήτηση'
              }
            },
            toolbar: {
              addRemoveColumns: "Προσθέστε ή αφαιρέστε κολώνες",
              showColumnsTitle: "Δείξτε κολώνες",
              addTooltip: "Προσθήκη",
              searchTooltip: "Αναζήτηση",
              searchPlaceholder: "Αναζήτηση",
              exportTitle: "Εξαγωγή",
              exportCSVName: "Εξαγωγή σε CSV",
              exportPDFName: "Εξαγωγή σε PDF",
            },

            pagination: {
              firstTooltip: "Πρώτη Σελίδα",
              lastTooltip: "Τελευταία Σελίδα",
              previousTooltip: "Προηγούμενη Σελίδα",
              nextTooltip: "Επόμενη Σελίδα",
              labelDisplayedRows: "{from}-{to} από {count}",
              labelRowsSelect: "Εγγραφές ανά Σελίδα",
            },
            grouping: {
              placeholder: "Σύρετε για να ομαδοποιήσετε",
              groupedBy: "Σύρετε για να ομαδοποιήσετε",
            },
            header: {
              actions: "Ενέργειες",
            },
          }}
          options={{
            searchFieldAlignment: "left",
            pageSize: 10,
            pageSizeOptions: [10, 15, 20],
            columnsButton: true,
            exportButton: true,
            exportPdf: (columns, data) => {
              exportPDF(columns, data);
            },
            exportCsv: (columns, data) => {
              exportCSV(columns, data);
            },
            grouping: false,
            sorting: true,
            filtering: true,
            search: false,
            exportAllData: true,
          }}
        />
      </CardBody>
    </Card>
  );
}

export default Devices;
